<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;  color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center; margin-top: -4vh;">
            <v-container grid-list-md class="mt-2">
              <v-layout wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <v-layout wrap>
                    <v-btn icon flat @click="backlink()">
                      <v-icon>navigate_before</v-icon>
                    </v-btn>
                    <h2 style="display: inline-block;margin-left: 1em;">รายการ BottomMenu</h2>
                  </v-layout>
                  <div>
                    <v-btn flat small style="background: #1b232f;color: white;border-radius: 4px;font-size: 14px;font-weight: 600;float: right;display: inline-flex;" @click="gotocreate()" v-if="list_bottommenu.length !== 0">
                      <v-icon style="font-size: 21px;font-weight: 600;">add</v-icon> &nbsp;&nbsp;สร้างใหม่
                    </v-btn>
                  </div>
                  <v-container style="text-align: center;padding-left: 0; padding-right: 0;">
                    <v-progress-circular :size="150" :width="7" color="#2562af" indeterminate v-if="progress" style="margin-top: 10vh;" />
                    <div v-else>
                      <div v-if="list_bottommenu.length===0">
                        <v-alert :value="true" color="#2562af" icon="priority_high" outline style="margin-top: 10vh;">
                          <h5 class="textAlert">ไม่มีการสร้าง bottom menu คุณสามารถสร้างใหม่ได้โดยคลิก "สร้างใหม่"</h5>
                        </v-alert>
                        <v-btn flat small style="border: 2px solid #2562af !important; background: #2562af;color: white;border-radius: 4px;font-size: 16px;" @click="gotocreate()">
                          <v-icon>add</v-icon> สร้างใหม่
                        </v-btn>
                      </div>
                      <div v-else class="ticket" v-for="(item,index) in list_bottommenu" @click="gotoedit(item.rich_menu_id)" style="cursor:pointer;">
                        <div :class="item.richmenu_status !== '0'? 'stub':'stub_closeside'">
                          <div v-if="item.type_menu === '1'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[2].picture,'100','100')" class="imageCover"></div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[3].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[4].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[5].picture,'100','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '2'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'150','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'150','100')" class="imageCover"></div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[2].picture,'150','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[3].picture,'150','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '3'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'300','100')" class="imageCover"></div>
                            </v-flex>
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[1].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[2].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[3].picture,'100','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '4'" class="tableShowTemplate">
                            <v-layout wrap>
                              <v-flex style="display: flex; padding: 0 !important;justify-content: flex-end;">
                                <div :style="backgroundDiv(item.list_menu[0].picture,'200','200')" class="imageCover"></div>
                              </v-flex>
                              <v-flex class="CenterTemplate">
                                <v-layout wrap style="justify-content: end;">
                                  <v-flex>
                                    <div :style="backgroundDiv(item.list_menu[1].picture,'100','100')" class="imageCover"></div>
                                    <div :style="backgroundDiv(item.list_menu[2].picture,'100','100')" class="imageCover"></div>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                          <div v-else-if="item.type_menu === '5'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'300','100')" class="imageCover"></div>
                            </v-flex>
                            <v-flex class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[1].picture,'300','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '6'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'150','200')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'150','200')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '7'" class="tableShowTemplate">
                            <v-flex s12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'300','200')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '8'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[2].picture,'100','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '9'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'100','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'200','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '10'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'200','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'100','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '11'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'150','100')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'150','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '12'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'300','100')" class="imageCover"></div>
                            </v-flex>
                          </div>
                          <div v-else-if="item.type_menu === '13'" class="tableShowTemplate">
                            <v-flex xs12 sm12 md12 lg12 xl12 class="CenterTemplate">
                              <div :style="backgroundDiv(item.list_menu[0].picture,'75','75')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[1].picture,'75','75')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[2].picture,'75','75')" class="imageCover"></div>
                              <div :style="backgroundDiv(item.list_menu[3].picture,'75','75')" class="imageCover"></div>
                            </v-flex>
                          </div>
                        </div>
                        <div :class="item.richmenu_status !== '0'? 'center':'center_close'">
                        </div>
                        <div :class="item.richmenu_status !== '0'? 'informationside':'information_closeside'">
                          <p class="big">{{item.richmenu_name}}</p>
                           <span class="statusBottommenu" v-if="item.richmenu_status === '1'">กำลังใช้งาน</span>

                          <div class="Kanit" style="text-align: left;margin-top: 30px;">
                            <p>สถานะ {{(item.richmenu_status === '0')? 'ปิด':'เปิด'}}</p>
                            <p>วันที่สร้าง {{ date(item.create_date) }} - {{ time(item.create_date) }}</p>
                          </div>
       
                        </div>
                      </div>
                
                    </div>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
  import { Momenttime } from '@/services'
export default {
  data () {
    return {
      progress: '',
      // lenght_of_api: 0,
      tokenbot: '',
      token: '',
      list_bottommenu: [],
      // header: [
      //   { text: 'ชื่อ', value: 'richmenu_name' },
      //   { text: 'รูป', value: 'type_menu' },
      //   { text: 'วันที่สร้าง', value: 'create_date' },
      //   { text: 'สถานะ', value: 'richmenu_status' }
      // ],
      // pagination: {
      //   sortBy: 'create_date',
      //   descending: true
      // },
      // data: []
    }
  },
  methods: {
    date (date) {
      return Momenttime.momentdatethai(date)
    },
    time (date) {
      return Momenttime.momenttimethai(date)
    },
    backgroundDiv (path, width, height) {
      return 'height: ' + height + 'px; width: ' + width + 'px; border: 1px solid black; background: url(\'' + path + '\';background-position: center !important; background-size: cover !important;'
    },
    backlink () {
      this.$router.go(-1)
    },
    gotocreate () {
      this.$router.push('/develop/bottommenu/create/' + this.tokenbot)
    },
    getListBottomMenu () {
      this.progress = true
      var body = {bot_id: this.tokenbot}
      this.$http.post(process.env.APImanage + '/get_list_richmenu', body).then((response) => {
        console.log(response.body)
        if (response.body.status === 'success') {
          this.list_bottommenu = response.body.list_richmenu
          this.progress = false
        } else {
          this.progress = false
        }
      }, (response) => {})
    },
    gotoedit (richmenuId) {
      this.$router.push('/develop/bottommenu/edit/' + this.tokenbot + '/' + richmenuId)
    }
  },
  mounted () {
  },
  components: {
  },
  watch: {
  },
  created () {
    this.token = localStorage.getItem('tokenuser')
    this.tokenbot = this.$route.params.tokenbot
    this.getListBottomMenu()
  }
}
</script>
<style type="text/css" scoped>
.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.buttonedit {
  border: solid 1px #DEE5EC !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}

.headerColor {
  margin-top: 10px;
  color: #2562af !important;
}

.textAlert {
  font-size: large;
}

.tableShowTemplate {
  padding-top: 5px !important;
  /*padding-bottom: 10px !important;*/
}

>>>.theme--light.v-datatable thead th.column.sortable {
  color: white !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}

>>>.theme--light.v-table thead tr:first-child {
  border-bottom: 1px solid rgba(0, 0, 0, 0.63) !important;
  background: #1b232e !important;
}

>>>.theme--light.v-datatable thead th.column.sortable.active .v-icon {
  color: white !important;
}

.imageCover {
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  background-color: initial;
}

.statusBottommenu {
  top: -2px;
  display: inline-block;
  padding: 4px 6px;
  border: 1px solid #24446e;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1em;
  border-radius: 4px;
  background-color: #24446e;
  color: #FFFFFF;
}


.CenterTemplate {
  display: flex;
  padding: 0 !important;
  justify-content: center;
}



.ticket {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 650px;
  margin: 20px auto;
}

.ticket:hover .stub {
  background: #2463af;
}

.ticket:hover .stub:before,
.ticket:hover .stub:after {
  border-left: 20px solid #2463af;
}

.ticket:hover .informationside {
  background: #232a35;
}

.ticket:hover .informationside:before,
.ticket:hover .informationside:after {
  border-right: 20px solid #232a35;
}


.ticket:hover .stub_closeside {
  background: #949494;
}

.ticket:hover .stub_closeside:before,
.ticket:hover .stub_closeside:after {
  border-left: 20px solid #949494;
}

.ticket:hover .information_closeside {
  background: #313131;
}

.ticket:hover .information_closeside:before,
.ticket:hover .information_closeside:after {
  border-right: 20px solid #313131;
}




.ticket .stub,
.ticket .stub_closeside,
.ticket .informationside,
.ticket .information_closeside {
  box-sizing: border-box;
  border-radius: 20px;
}


.ticket .center {
  border: none;
  border-left: 5px white dashed;
  width: 5px;
  background: #2562af;
  height: 230px
}

.ticket .center_close {
  border: none;
  border-left: 5px white dashed;
  width: 5px;
  background: #949494;
  height: 230px
}

.stub {
  background: #e0eeff;
  height: 250px;
  width: 400px;
  color: white;
  padding: 20px;
  position: relative;
}
.stub_closeside {
  background: #dadada;
  height: 250px;
  width: 400px;
  color: white;
  padding: 20px;
  position: relative;
}
.stub_closeside:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border-top: 20px solid white;
  border-left: 20px solid #dadada;
  width: 0;
}

.stub_closeside:after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  border-bottom: 20px solid white;
  border-left: 20px solid #dadada;
  width: 0;
}

.stub:before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  border-top: 20px solid white;
  border-left: 20px solid #e0eeff;
  width: 0;
}

.stub:after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  border-bottom: 20px solid white;
  border-left: 20px solid #e0eeff;
  width: 0;
}

.information_closeside {
  background: #949494;
  height: 250px;
  width: 250px;
  padding: 20px;
  position: relative;
  color: white;
}
.information_closeside:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-top: 20px solid white;
  border-right: 20px solid #949494;
  width: 0;
}

.information_closeside:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom: 20px solid white;
  border-right: 20px solid #949494;
  width: 0;
}



.informationside {
  background: #2463af;
  height: 250px;
  width: 250px;
  padding: 20px;
  position: relative;
  color: white;
}

.informationside:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  border-top: 20px solid white;
  border-right: 20px solid #2463af;
  width: 0;
}

.informationside:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom: 20px solid white;
  border-right: 20px solid #2463af;
  width: 0;
}

.informationside .big, .information_closeside .big{
  font-size: 20px;
    font-weight: 700;
    margin-bottom: 0px !important;
}

.informationside .information, .information_closeside .information {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  font-size: 12px;
  margin-top: 20px;
  width: 100%;
}


/*313131*/

/*.informationside .information section, .information_closeside .information section {
  margin-right: 50px;
}

.informationside .information section:before,.information_closeside .information section:before{
  content: '';
  background: #ef5658;
  display: block;
  width: 40px;
  height: 3px;
  margin-bottom: 5px;
}*/


</style>



// WEBPACK FOOTER //
// src/components/managebot/bottommenu/list_bottommenu.vue